import useNewThumbnailsEnabled from '~/client/hooks/feature/useNewThumbnailsEnabled';
import useAgentData from '~/client/hooks/useAgentData';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';
import useGameNameLanguage from '~/client/hooks/user/useGameNameLanguage';
import useSite from '~/client/hooks/useSite';
import type { GamesListQueryVariables } from '~/client/shared/game/GameList/graphql/GamesListQuery.generated';
import type { currencyConversion } from '~/schema/public';
import getRtpFilters from '~/shared/utils/carousel/getRtpFilters';

type Props = Omit<GameListProps, 'pageTitle' | 'pageSection'> & {
  sort: -1 | 1;
  sortType: SortOptions;
  categories?: string[];
  providers?: string[];
};

const useGameListVariables = ({
  theme,
  sortType = 'popular',
  sort = -1,
  menuItem = 'all-games',
  categories = [],
  providers = [],
}: Props) => {
  const newThumbsEnabled = useNewThumbnailsEnabled();
  const language = useGameNameLanguage();
  const { site } = useSite();
  const { deviceType: type, isDesktop } = useAgentData();
  const { walletCurrency } = useCurrentUser();
  const currency = (walletCurrency as currencyConversion) || 'BTC';
  const menuItemSec = [...categories, ...providers].join() || undefined;
  const rtpFilters = getRtpFilters(sortType);
  const desktopGamesCount = newThumbsEnabled ? 35 : 30;
  const variables: GamesListQueryVariables = {
    first: isDesktop ? desktopGamesCount : 12,
    language,
    currency,
    filter: {
      site,
      type,
      currency,
      menuItemSec,
      theme,
      menuItem: menuItem ?? undefined,
      ...rtpFilters,
    },
    favouritesFilter: { site, type },
    recentsFilter: { site, type },
    skipFavourites: menuItem !== 'favourite',
    skipRecents: menuItem !== 'recent',
    skipRegular: menuItem === 'recent' || menuItem === 'favourite',
    sort: { [sortType]: sort, language },
  };

  return variables;
};

export default useGameListVariables;
